import { CompletePropertyDto } from 'services/properties/property-complete.dto';

export class PropertyPhotoDto {
    id!: number;
    fileUrl!: string;
    fileKey!: string;
    order!: number;
    propertyId!: number;
}

export class SaleListingDto {
    id!: number;
    salePropertyId!: number;
    portalId!: number;
    externalId?: string;
    externalUrl?: string;
    status!: 'active' | 'paused' | 'closed' | 'error';
    listingTypeId?: string;
    mlCategoryId?: string;
    publishedAt?: string;
    lastSyncedAt?: string;
}

export class SalePropertyDto {
    id!: number;
    propertyId!: number;
    price!: number;
    currency!: 'USD' | 'ARS';
    description?: string;
    createdAt?: string;
    updatedAt?: string;
    property?: CompletePropertyDto & { photos?: PropertyPhotoDto[] };
    listings?: SaleListingDto[];
}

export class CreateSalePropertyDto {
    price!: number;
    currency!: 'USD' | 'ARS';
    description?: string;
}

export class PublishListingDto {
    portalId!: number;
    listingTypeId!: string;
    mlCategoryId!: string;
    mlNeighborhoodId!: string;
    rooms?: number;
    bathRooms?: number;
    parkingLots?: number;
}

export class MLNeighborhoodDto {
    id!: string;
    name!: string;
    city?: { name: string };
    state?: { name: string };
}

export const ML_CATEGORIES: Record<string, string> = {
    MLA1466: 'Casa',
    MLA1472: 'Departamento',
    MLA50541: 'Cochera',
    MLA1475: 'Depósito y Galpón',
    MLA1496: 'Campo',
    MLA392265: 'Consultorio',
    MLA50545: 'Fondo de Comercio',
};

export const ML_LISTING_TYPES: { value: string; label: string }[] = [
    { value: 'gold_special', label: 'Destacado' },
    { value: 'gold_pro', label: 'Premium' },
    { value: 'gold', label: 'Clásico' },
    { value: 'silver', label: 'Económico' },
];

export const ML_PORTAL_ID = 1;
